import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Container } from '@mui/material';
import PageHeaders from '../../../Utils/PageHeaders';
import HeroSection from './components/HeroSection';
import PartnersSection from './components/PartnersSection';
import WhatPlootusDoes from './components/WhatPlootusDoes';
import FinanceFeatures from './components/FinanceFeatures';
import RetirementCalculator from './components/RetirementCalculator';
import HomeNewsSection from './components/HomeNewsSection';
import TestimonialsSection from './components/TestimonialsSection';
import BlogSection from './components/BlogSection';
import HubNav from '../../ResourceHubPages/HubNav/HubNav';

const useStyles = makeStyles((theme) => ({
  root: {
    // paddingTop: theme.spacing(4),
    width: '100%',
  },
  container: {
    maxWidth: '100%',
    padding: 0,
    margin: 0,
  },
}));

const Home = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <PageHeaders
        title="Plootus - Free AI-Powered 401k & Retirement Planning | Plootus"
        description="Plootus is a free, AI-driven retirement planning platform that analyzes your 401(k), 403(b), 457, and TSP plans — recommending the best funds, minimizing fees, and keeping you on track for retirement. No SSN required."
        keywords="retirement planning, 401k calculator, financial planning, investment advice, retirement savings, pension planning, wealth management"
        canonicalUrl="https://www.plootus.com/"
        ogTitle="Free AI-Powered 401k & Retirement Planning | Plootus"
        ogDescription="AI-driven 401k and retirement planning — free, unbiased, and personalized. Find your employer's plan, get fund recommendations, and optimize your portfolio in minutes."
        ogImage="A branded 1200×630px image summarizing the product value prop (required for social sharing previews)"
      />
     <HubNav />
      {/* after removing the hub nav make sure to restore the root padding */}
      <Container>
        <HeroSection />
        <PartnersSection />
        <WhatPlootusDoes />
        <FinanceFeatures />
        <RetirementCalculator />
        <HomeNewsSection />
        <TestimonialsSection />
        <BlogSection />
      </Container>
    </div>
  );
};

export default Home;
